import {
  CheckCircleFilled,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Spin } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import BASE_URL from '../../configs/baseUrl';
import AccountCard from '../accountCard';
import Backdrop from '../backdrop';
import onSwitchAccount, { onLogoutHandler } from './account.handler';
import { SwitchAccountWrapper } from './style';
import { AuthService } from '../../services';

// const roleAs = (roles) => {
//   const listOfRoles = roles?.data || [];
//   if (listOfRoles.length > 0) {
//     return listOfRoles.map(() => {
//       return `as ${listOfRoles
//         .map((items) => {
//           return items?.name;
//         })
//         .join(', ')}`;
//     });
//   }
//   return '-';
// };

const SwitchAccountComponent = (props) => {
  const history = useHistory();
  const { isShow, userData, defaultTeam, selectedTeam, teamList } = props;
  const [isLoadingSwitch, setIsLoadingSwitch] = useState(false);
  const [isLoadingLogout, setIsLoadingLogout] = useState(false);

  const teamData = AuthService.getTeamData();

  const onClickAccount = () => {
    history.push(BASE_URL.ACCOUNTS);
  };

  const onRedirectToLandingPage = () => {
    window.location.replace(BASE_URL.LANDING);
  };

  const onChangeAccount = (id) => {
    const body = {
      team_id: id,
    };
    onSwitchAccount({ body, setIsLoadingSwitch, onRedirectToLandingPage });
  };

  const onSignOut = () => {
    onLogoutHandler({ setIsLoadingLogout });
  };
  const filteredTeam = teamList.filter((item) => {
    return item?.team_id !== teamData?.team_id;
  });

  return (
    <SwitchAccountWrapper isShow={isShow}>
      <Backdrop show={isLoadingLogout} />

      <Spin spinning={isLoadingSwitch}>
        <div className="container_page_header_switch_account">
          <div className="component_switch_account_body">
            <div
              aria-hidden="true"
              className={`component_switch_account_list_item ${
                selectedTeam === defaultTeam ? 'active' : ''
              }`}
              onClick={() => {
                onChangeAccount(defaultTeam);
              }}
            >
              <AccountCard
                name={userData?.name}
                description={userData?.email}
                profilePicDocument={userData?.profile_pic_document}
              />
              {selectedTeam === defaultTeam && (
                <CheckCircleFilled className="component_switch_account_list_item_icon" />
              )}
            </div>
            {filteredTeam.map((item) => {
              const profilePicDocument = item?.team?.profile_pic_document;
              return (
                <div
                  aria-hidden="true"
                  key={item?.team_id}
                  className={`component_switch_account_list_item ${
                    selectedTeam === item?.team_id ? 'active' : ''
                  }`}
                  onClick={() => {
                    onChangeAccount(item?.team_id);
                  }}
                >
                  <AccountCard
                    className="component_page_header_account_card"
                    name={item.team.name}
                    description={`as ${item?.role?.name}`}
                    profilePicDocument={profilePicDocument}
                  />
                  {selectedTeam === item?.team_id && (
                    <CheckCircleFilled className="component_switch_account_list_item_icon" />
                  )}
                </div>
              );
            })}
          </div>
          <div className="component_switch_account_footer">
            <div
              className="component_switch_account_footer_item"
              aria-hidden="true"
              onClick={onClickAccount}
            >
              <UserOutlined />
              <div className="font-subtitle2_medium text">My Account</div>
            </div>
            <div
              className="component_switch_account_footer_item"
              aria-hidden="true"
              onClick={onSignOut}
            >
              <LogoutOutlined />
              <div className="font-subtitle2_medium text">Sign Out</div>
            </div>
          </div>
        </div>
      </Spin>
    </SwitchAccountWrapper>
  );
};

export default SwitchAccountComponent;
